import React, { useEffect, useState } from 'react';
import PersonPrograms from 'containers/pages/persons/PersonPrograms';
import AddProgramModal from 'containers/pages/exercises/programs/AddProgramModal';
import { ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM } from 'routes/RouteList';
import { useParams } from 'react-router-dom';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/icon/Icon';
import messages from 'messages';
import { Button } from 'components/button';

const PersonProgramsTab = () => {
  const { entityId, groupId, personId } = useParams();
  const { addActionButton } = useContextMenu();
  const [modalData, setModalData] = useState(null);
  const person = useEntityContext(s => s.person);

  const AddProgramBtn = () => (
    <Button rounded primary onClick={() => setModalData(true)}>
      <Icon id="add-white" />
      <FormattedMessage {...messages.exercisesAddProgramButton} />
    </Button>
  );

  useEffect(() => {
    addActionButton(AddProgramBtn);

    return () => {
      addActionButton(null); // Clear the action button when component unmounts
    };
  }, [personId]);

  return (
    <>
      <PersonPrograms />

      {modalData && (
        <AddProgramModal
          entityId={entityId}
          destiny={{
            path: ROUTE_PERSONS_ENTITY_PERSON_PROGRAMS_ENTITY_PROGRAM,
            variables: { entityId, groupId, personId }
          }}
          program={{
            entityId,
            title: '',
            startdate: '',
            duration: '',
            description: '',
            exerciseIds: [],
            exercises: []
          }}
          persons={[person]}
          onClose={() => setModalData(null)}
        />
      )}
    </>
  );
};

export default PersonProgramsTab;
